module.exports = __webpack_public_path__ + "static/WindingWorlds5-c97f6e43506708ff4f63e9d4ee4700bd.png";